import { vyDate } from '@vy/utils';

const PRODUCT_COLOR_PALETTE = [
  '#81B3FF',
  '#697DFC',
  '#78D6DC',
  '#F4BA61',
  '#1D68C8',
  '#1D68C8',
  '#CFE6FF',
  '#C265EC',
  '#FFD0D8',
  '#87DE9C',
];

export function formatMonthLabel(dateLabel: string) {
  const date = vyDate(dateLabel);

  return date.format('MMM');
}

export function setColorFromPalette(index: number) {
  return PRODUCT_COLOR_PALETTE[index % PRODUCT_COLOR_PALETTE.length];
}
